import { render, staticRenderFns } from "./bookSuggestionsWeb.vue?vue&type=template&id=be612008&scoped=true&"
import script from "./bookSuggestionsWeb.vue?vue&type=script&lang=js&"
export * from "./bookSuggestionsWeb.vue?vue&type=script&lang=js&"
import style0 from "./bookSuggestionsWeb.vue?vue&type=style&index=0&id=be612008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be612008",
  null
  
)

export default component.exports